import React from 'react'
import {timeSince} from './utils'
import {Badge} from './components/Badge'
import {getBadgeDetails} from '@cssbattle/shared/badges'

const NotificationItem = ({
  imageUrl,
  actionLink,
  timeStamp,
  children,
  type,
  badgeId,
  badgeMetadata,
}) => {
  const defaultImg = (
    <svg style={{width: '30px', height: '30px'}} viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M12 19.2c-2.5 0-4.71-1.28-6-3.2.03-2 4-3.1 6-3.1s5.97 1.1 6 3.1a7.232 7.232 0 0 1-6 3.2M12 5a3 3 0 0 1 3 3 3 3 0 0 1-3 3 3 3 0 0 1-3-3 3 3 0 0 1 3-3m0-3A10 10 0 0 0 2 12a10 10 0 0 0 10 10 10 10 0 0 0 10-10c0-5.53-4.5-10-10-10z"
      />
    </svg>
  )

  // For badge notifications
  const badgeContent =
    type === 'badge' && badgeId ? (
      <>
        <div className="notification-item__image">
          <Badge
            badgeId={badgeId}
            metadata={badgeMetadata}
            size="small"
            showTooltip={false}
            particles={false}
          />
        </div>
        <div className="notification-item__text">
          {children ||
            `You earned the "${
              getBadgeDetails(badgeId)?.name || 'New'
            }" badge!`}
          <div className="notification-item__time">
            {timeSince(timeStamp)} ago
          </div>
        </div>
      </>
    ) : (
      <>
        <div className="notification-item__image">
          {imageUrl ? <img src={imageUrl} alt="" /> : defaultImg}
        </div>
        <div className="notification-item__text">
          {children}
          <div className="notification-item__time">
            {timeSince(timeStamp)} ago
          </div>
        </div>
      </>
    )

  return (
    <div
      className={`notification-item ${
        type ? `notification-item--${type}` : ''
      }`}
    >
      <div className="notification-item__content">{badgeContent}</div>

      {actionLink ? <a href={actionLink} className="shadow-link" /> : null}
    </div>
  )
}

export {NotificationItem}
